export default "__VITE_ASSET__3110d832__"